"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      position: 'absolute'
    },
    paperRoot: {
      width: '402px',
      position: 'absolute',
      boxShadow: '0px 0px 0px 0px #fff, 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 0px 0px 0px #fff'
    },
    icon: {
      marginRight: spacing(1)
    },
    chip: {
      margin: spacing(0, 0.25, 0.5, 0.25)
    }
  };
});

var MarketplaceFilters = function MarketplaceFilters(_ref2) {
  var isOpen = _ref2.isOpen,
      onClose = _ref2.onClose,
      onFilter = _ref2.onFilter,
      types = _ref2.types,
      setTypes = _ref2.setTypes,
      categories = _ref2.categories,
      setCategories = _ref2.setCategories,
      filters = _ref2.filters;
  var classes = useStyles();
  var onCategoryUnselect = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    var value = event.currentTarget.dataset.value;
    setCategories(categories.filter(function (category) {
      return category.value !== Number(value);
    }));
  }, [setCategories, categories]);
  var onSetCategory = (0, _react.useCallback)(function (event) {
    setCategories(event.target.value);
  }, [setCategories]);
  var renderSelectedCategories = (0, _react.useCallback)(function (selected) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      flexWrap: "wrap"
    }, selected.map(function (category) {
      return /*#__PURE__*/_react.default.createElement(_material.Chip, {
        size: "small",
        key: category.value,
        className: classes.chip,
        onDelete: function onDelete() {},
        deleteIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
          "data-value": category.value,
          onMouseDown: onCategoryUnselect,
          icon: "times-circle"
        }),
        label: category.label
      });
    }));
  }, [classes, onCategoryUnselect]);
  return /*#__PURE__*/_react.default.createElement(_material.Drawer, {
    open: isOpen,
    disablePortal: true,
    hideBackdrop: true,
    transitionDuration: 0,
    anchor: "right",
    style: {
      position: 'absolute'
    },
    classes: {
      root: classes.root
    },
    PaperProps: {
      classes: {
        root: classes.paperRoot
      },
      'data-testid': 'CreateGift.MarketplaceFilters'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    pb: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "H4-Dark"
  }, "Filters"), /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "times",
    onClick: onClose
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 2,
    mb: 2,
    borderRadius: "5px",
    bgcolor: "common.white"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Label-Table-Left-Active"
  }, "ITEM TYPES"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    pb: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Divider, null)), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "Column"
  }, filters.types.map(function (type) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      key: type.value
    }, /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
      control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
        color: "secondary",
        checked: !!types[type.value],
        value: type.value,
        onChange: function onChange(e) {
          return setTypes(_objectSpread(_objectSpread({}, types), {}, {
            [type.value]: e.target.checked
          }));
        }
      }),
      label: type.label
    }));
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 2,
    borderRadius: "5px",
    bgcolor: "common.white"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Label-Table-Left-Active"
  }, "CATEGORIES"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Divider, null)), /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
    id: "marketplace-filters-categories-label"
  }, "Select a category"), /*#__PURE__*/_react.default.createElement(_material.Select, {
    multiple: true,
    label: "Select a category",
    value: categories,
    onChange: onSetCategory,
    renderValue: renderSelectedCategories,
    id: "marketplace-filters-categories-select",
    labelId: "marketplace-filters-categories-label"
  }, filters.categories.map(function (category) {
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: category.value,
      value: category
    }, category.label);
  })))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    pt: 2,
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    fullWidth: true,
    variant: "contained",
    color: "secondary",
    onClick: onFilter
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    className: classes.icon,
    color: "inherit",
    icon: "check"
  }), "Apply filters"))));
};

MarketplaceFilters.propTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onFilter: _propTypes.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  types: _propTypes.default.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  categories: _propTypes.default.array.isRequired,
  setTypes: _propTypes.default.func.isRequired,
  setCategories: _propTypes.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  filters: _propTypes.default.object.isRequired
};
var _default = MarketplaceFilters;
exports.default = _default;